import axios from "axios";
import FeatherIcon from "feather-icons-react";
import React, { Component } from "react";
import StudentLine from "../students/StudentLine";

class LessonStaff extends Component {
  state = { labels: [], data: [], dataHour: [], loading: true, loadError: "" };

  componentDidMount() { this.getStaffs(); }

  getStaffs = async () => {
    this.setState({ loading: true, loadError: "" });
    try {
      const response = await axios.get("staffs");
      const labels = [], data = [], dataHour = [];
      (Array.isArray(response.data) ? response.data : []).forEach((staff) => {
        const lessons = Array.isArray(staff.sectionclasselessons) ? staff.sectionclasselessons : [];
        const weekHours = lessons.reduce(
          (total, lesson) => total + Math.max(Number(lesson?.week_hour) || 0, 0), 0,
        );
        const name = [staff?.matricule, staff?.user?.last_name, staff?.user?.family_name]
          .filter(Boolean).join(" ");
        labels.push(name || "Personnel");
        data.push(lessons.length);
        dataHour.push(weekHours);
      });
      this.setState({ labels, data, dataHour });
    } catch (error) {
      this.setState({ loadError: "Les statistiques pédagogiques sont indisponibles." });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { labels, data, dataHour, loading, loadError } = this.state;
    const totalCourses = data.reduce((total, value) => total + value, 0);
    const totalHours = dataHour.reduce((total, value) => total + value, 0);
    const averageHours = labels.length
      ? (totalHours / labels.length).toLocaleString("fr-FR", { maximumFractionDigits: 1 }) : 0;

    if (loading) return (
      <div className="lesson-staff-state" role="status">
        <span className="lesson-staff-loader" /><p>Calcul de la charge pédagogique…</p>
      </div>
    );
    if (loadError) return (
      <div className="lesson-staff-state lesson-staff-state--error">
        <FeatherIcon icon="alert-circle" size={25} /><p>{loadError}</p>
        <button type="button" onClick={this.getStaffs}>Réessayer</button>
      </div>
    );
    if (!labels.length) return (
      <div className="lesson-staff-state">
        <FeatherIcon icon="book-open" size={26} />
        <p>Aucune charge de cours à présenter pour le moment.</p>
      </div>
    );

    return (
      <div className="lesson-staff">
        <div className="lesson-staff-summary">
          <article><i><FeatherIcon icon="users" size={17} /></i><span><b>{labels.length}</b><small>Personnel suivi</small></span></article>
          <article><i><FeatherIcon icon="clock" size={17} /></i><span><b>{totalHours}</b><small>Heures par semaine</small></span></article>
          <article><i><FeatherIcon icon="book-open" size={17} /></i><span><b>{totalCourses}</b><small>Cours attribués</small></span></article>
          <article><i><FeatherIcon icon="trending-up" size={17} /></i><span><b>{averageHours}</b><small>Heures moyennes</small></span></article>
        </div>
        <div className="lesson-staff-grid">
          <article className="lesson-staff-chart">
            <header><i><FeatherIcon icon="clock" size={18} /></i><div><span>Volume hebdomadaire</span><h3>Heures dispensées par semaine</h3></div></header>
            <StudentLine labels={labels} data={dataHour} matricule={this.props.matricule || ""} name={this.props.name} title="Heures dispensées par semaine" />
          </article>
          <article className="lesson-staff-chart lesson-staff-chart--courses">
            <header><i><FeatherIcon icon="book" size={18} /></i><div><span>Répartition des cours</span><h3>Nombre de cours par membre</h3></div></header>
            <StudentLine labels={labels} data={data} matricule={this.props.matricule || ""} name={this.props.name} title="Nombre de cours par membre du personnel" />
          </article>
        </div>
      </div>
    );
  }
}

export default LessonStaff;
